import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const AlertContainer = styled.div`
	display: flex;
	gap: 15px;
	justify-content: flex-start;
	padding-bottom: 20px;

	& svg {
		margin-top: -6px;
	}
`;

export const UploadContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 25px 0px;

	& > div {
		width: 100%;
		height: 45px;
		background-color: #fff;
		& > div:nth-child(1) {
			background-color: ${tokens.color_gray_light};
		}
		& > div:nth-child(2) {
			height: 45px;
		}
		label {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 45px;
		}
	}
`;
